import { Vue } from "vue-class-component";
import { Model } from "vue-property-decorator";
import {
    APIResponse,
    OrderPaymentDetailsDto,
    PaymentDto,
    PaymentType,
    PostOrderPaymentsRequestBody,
} from "@/shared/api-contract/api-contract";
import { appAxios } from "@/core/utils/appAxios";

export class ManualTransferPopup extends Vue {
    @Model("_isProcessingPayment", { required: true })
    isProcessingPayment!: boolean;
    @Model("_orderId", { required: true })
    orderId!: number;
    @Model("_vehiclesId", { required: true, default: [] })
    vehiclesId!: string[];
    paymentDto: PaymentDto[] = [];

    closePopup() {
        if (!this.isProcessingPayment) {
            this.$router.back();
        }
        this.$emit("close");
    }

    mounted() {
        if (this.isProcessingPayment) {
            this.getManualInfo();
        } else {
            this.selectManual();
        }
    }

    async getManualInfo() {
        this.getOrderPayments().catch((e) => {
            console.error("Error fetching manual payment info:", e);
        });
    }

    async selectManual() {
        try {
            this.paymentDto = await this.postOrderPayments(
                this.orderId,
                this.vehiclesId,
                PaymentType["Manual Transfer"],
            );
        } catch (error) {
            console.error("Error fetching manual payment:", error);
        }
    }

    async getOrderPayments(): Promise<PaymentDto[] | void> {
        return appAxios.value
            .get<APIResponse<OrderPaymentDetailsDto>>(
                `/client/web/orders/${this.orderId}/payments`,
            )
            .then((r) => {
                this.paymentDto = r.data.data.payments.filter(
                    (pay) => pay.status.id === 1,
                );
                return r.data.data.payments;
            })
            .catch((e) => {
                console.error("Error fetching manual payment info:", e);
            });
    }

    async postOrderPayments(
        orderId: number,
        vehiclesId: string[],
        paymentType: PaymentType,
    ): Promise<PaymentDto[]> {
        const payload: PostOrderPaymentsRequestBody = {
            id_payment_type: paymentType,
            ids_order_vehicles: vehiclesId,
        };

        const response = await appAxios.value.post<APIResponse<PaymentDto[]>>(
            `/client/web/orders/${orderId}/payments`,
            payload,
        );

        return response.data.data;
    }
}
